import { Box, CircularProgress, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './useStyle'
import { useDispatch } from 'react-redux'
import { enableAdminUserME } from '../../../../../redux/actions/Instances'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  height: 225,
  bgcolor: 'white',
  p: 3,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export const ModalChangeAdminME = ({
  userId,
  modalChangeUserAdmin,
  setModalChangeUserAdmin
}) => {
  const classes = useStyles()
  const [showCircularProgress, setShowCircularProgress] = useState(false)
  const dispatch = useDispatch()

  const handleChangeUserAdmin = async () => {
    setShowCircularProgress(true)
    if (userId) await dispatch(enableAdminUserME(userId))
    setShowCircularProgress(false)
    setModalChangeUserAdmin(false)
  }

  return (
    <>
      <Modal
        open={modalChangeUserAdmin}
        onClose={() => setModalChangeUserAdmin(false)}
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon
              sx={{
                fontSize: 'medium',
                color: '#263057',
                cursor: 'pointer'
              }}
              onClick={() => setModalChangeUserAdmin(false)}
            />
          </div>
          <div>
            <Typography sx={{ color: '#263057', fontSize: '1.3em' }}>
              Configurar usuario Mi Estudio
            </Typography>
          </div>
          <Typography
            sx={{
              color: '#263057',
              fontFamily: 'Roboto',
              marginTop: '5%'
            }}
          >
            ¿Desea configurar Mi Estudio al usuario?
          </Typography>

          <Box className={classes.buttons} style={{ marginLeft: '45%' }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              handleChangeUserAdmin={handleChangeUserAdmin}
            />
            <ButtonClose handleClose={() => setModalChangeUserAdmin(false)} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm ({ showCircularProgress, handleChangeUserAdmin }) {
  const classes = useStyles()

  return (
    <button className={classes.confirmButton}>
      {showCircularProgress
        ? (
        <CircularProgress size="1.5rem" color="inherit" />
          )
        : (
        <Typography
          className={classes.confirmButtonTypography}
          variant="contained"
          onClick={handleChangeUserAdmin}
        >
          Confirmar
        </Typography>
          )}
    </button>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
